<template>
  <el-col :span="5" style="height: 100%;">
        <div class="conversion">
            <div class="head">
                <span>提高会员转换</span>
                <img src="../../assets/images/home/more.png" alt="">
            </div>
        </div>
  </el-col>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.conversion{
    height: 100%;
    background:rgba(255,255,255,1);
    box-shadow:0px 4px 8px rgba(0,0,0,0.06);
    border-radius:6px;
    .head {
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 54px;
        padding: 0 24px;
        span {color: #2E3458; font-size: 16px; font-weight: 800;}
        img {width: 18px; height: 18px; cursor: pointer;}
        border-bottom: 1px solid #F6F6F6;
    }
}
</style>